import React from 'react';

export default class CalcHeader extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const flex_class = this.props.is_date_select ? 'header-block-2' : 'header-block-3';
        return (
            <div className={`calc-header-flex ${this.props.className ?? ''}`}>
                <div className={`${flex_class} ${this.props.active_page === 0 ? 'active' : ''}`}>情報入力</div>
                {
                    !this.props.is_date_select &&
                    <div className={`${flex_class} ${this.props.active_page === 1 ? 'active' : ''}`}>日付／時間帯<br/>選択</div>
                }
                <div className={`${flex_class} ${this.props.active_page === 2 ? 'active-end' : ''}`}>メニュー選択<br/>計算結果</div>
            </div>
        );
    }
}